// Auto-generated — DO NOT EDIT.

export enum ErrorReasonEnum {
  AdvisorSignInEmailNotFound = 'ERROR_AdvisorSignIn_EmailNotFound',
  AdvisorSignInInvalidCredentials = 'ERROR_AdvisorSignIn_InvalidCredentials',
  AdvisorSignInSSOAccountDoesntExist = 'ERROR_AdvisorSignIn_SSO_AccountDoesntExist',
  AdvisorSignInSSODomainNotAllowed = 'ERROR_AdvisorSignIn_SSO_DomainNotAllowed',
  AdvisorSignInTimeout = 'ERROR_AdvisorSignIn_Timeout',
  AdvisorUserResetPasswordExpiredCode = 'ERROR_AdvisorUserResetPassword_ExpiredCode',
  AdvisorUserResetPasswordInvalidCode = 'ERROR_AdvisorUserResetPassword_InvalidCode',
  ClientSignInEmailNotFound = 'ERROR_ClientSignIn_EmailNotFound',
  ClientSignInExpiredCode = 'ERROR_ClientSignIn_ExpiredCode',
  ClientSignInInvalidCode = 'ERROR_ClientSignIn_InvalidCode',
  DeleteAdvisorUserClientUsersExist = 'ERROR_DeleteAdvisorUser_ClientUsersExist',
  DeleteAdvisorUserManagementReferencesToAdvisorUsersExist = 'ERROR_DeleteAdvisorUser_ManagementReferencesToAdvisorUsersExist',
  DeleteAdvisorUserManagementReferencesToCompaniesExist = 'ERROR_DeleteAdvisorUser_ManagementReferencesToCompaniesExist',
  DeleteAdvisorUserReferralsExist = 'ERROR_DeleteAdvisorUser_ReferralsExist',
  DeleteCompanyAdvisorUsersExist = 'ERROR_DeleteCompany_AdvisorUsersExist',
  DeleteCompanyAffiliatesExist = 'ERROR_DeleteCompany_AffiliatesExist',
  DeleteCompanyClientUsersExist = 'ERROR_DeleteCompany_ClientUsersExist',
  DeleteCompanyManagingAdvisorUsersExist = 'ERROR_DeleteCompany_ManagingAdvisorUsersExist',
  JwtTokenExpired = 'ERROR_JwtToken_Expired',
  JwtTokenInvalidApplication = 'ERROR_JwtToken_InvalidApplication',
  JwtTokenInvalidToken = 'ERROR_JwtToken_InvalidToken',
  MortgageProductDelisted = 'ERROR_MortgageProduct_Delisted',
  MortgageNotComparableClosed = 'ERROR_Mortgage_NotComparable_Closed',
  MortgageNotComparableNoComparisonData = 'ERROR_Mortgage_NotComparable_NoComparisonData',
  MortgageNotComparableTermEnded = 'ERROR_Mortgage_NotComparable_TermEnded',
  MortgageNotComparableZeroOutstandingBalance = 'ERROR_Mortgage_NotComparable_ZeroOutstandingBalance',
  ReassignAdvisorUserClientUsersExist = 'ERROR_ReassignAdvisorUser_ClientUsersExist',
  ReassignAdvisorUserManagementReferencesToAdvisorUsersExist = 'ERROR_ReassignAdvisorUser_ManagementReferencesToAdvisorUsersExist',
  ReassignAdvisorUserManagementReferencesToCompaniesExist = 'ERROR_ReassignAdvisorUser_ManagementReferencesToCompaniesExist',
  ReassignAdvisorUserReferralsExist = 'ERROR_ReassignAdvisorUser_ReferralsExist',
  UnsubscribeCodeClientNotFound = 'ERROR_UnsubscribeCode_ClientNotFound',
  UnsubscribeCodeExpired = 'ERROR_UnsubscribeCode_Expired',
  UnsubscribeCodeInvalid = 'ERROR_UnsubscribeCode_Invalid',
}
